var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 101,
    viewBox: "0 0 223 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 222,
    height: 99.539,
    rx: 7.05932,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 222,
    height: 99.539,
    rx: 7.05932,
    stroke: "#D2D2D2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2881,
    y: 13.6067,
    width: 97.668,
    height: 12.2085,
    rx: 6.10425,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5487,
    y: 32.0874,
    width: 67.1467,
    height: 3.05212,
    rx: 1.52606,
    fill: "#F4F4F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.678,
    y: 44.9958,
    width: 15.5752,
    height: 2.59587,
    rx: 1.29794,
    fill: "#938C8C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7429,
    y: 50.2524,
    width: 82.9381,
    height: 10.2537,
    rx: 2.53097,
    stroke: "#4D4D4D",
    strokeWidth: 0.129794
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 116.498,
    y: 44.9958,
    width: 15.5752,
    height: 2.59587,
    rx: 1.29794,
    fill: "#938C8C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 116.563,
    y: 50.2524,
    width: 82.9381,
    height: 10.2537,
    rx: 2.53097,
    stroke: "#4D4D4D",
    strokeWidth: 0.129794
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.678,
    y: 70.4275,
    width: 15.5752,
    height: 2.59587,
    rx: 1.29794,
    fill: "#938C8C"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7429,
    y: 75.684,
    width: 176.758,
    height: 10.2537,
    rx: 2.53097,
    stroke: "#4D4D4D",
    strokeWidth: 0.129794
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.dac4eaedeb6bea1388a450616c6dcf09.svg";
export { ForwardRef as ReactComponent };